import type { JSONContent } from '@tiptap/core';

const personaIdOf = (block: JSONContent): string | undefined =>
  typeof block.attrs?.personaId === 'string' ? block.attrs.personaId : undefined;

// Stamp each dBlock with showName/showAvatar based on its neighbours in the full
// sequence: the name shows on the first block of a speaker run, the avatar on the
// last. Computed here (not in the NodeView from live editor state) so grouping
// stays correct as later same-speaker blocks are appended. Non-dBlock nodes
// (reply echoes, quiz blocks) break a run and are left untouched.
export function withGrouping(blocks: JSONContent[]): JSONContent[] {
  return blocks.map((block, index) => {
    if (block.type !== 'dBlock') {
      return block;
    }
    const personaId = personaIdOf(block);
    const previous = blocks[index - 1];
    const next = blocks[index + 1];
    const showName = !previous || previous.type !== 'dBlock' || personaIdOf(previous) !== personaId;
    const showAvatar = !next || next.type !== 'dBlock' || personaIdOf(next) !== personaId;
    return { ...block, attrs: { ...block.attrs, showName, showAvatar } };
  });
}
